(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3256],{

/***/ 44203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50066);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);



var StyledContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "KeyboardNavigation__StyledContainer",
  componentId: "sc-mrb9q4-0"
})(["display:", ";position:fixed;z-index:1500;margin:0 auto;width:100%;", "{top:10px;}"], function (p) {
  return p !== null && p !== void 0 && p.hidden ? "none" : "block";
}, function (p) {
  return p.theme.breakpoints.down("sm");
});
var StyledNavContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "KeyboardNavigation__StyledNavContainer",
  componentId: "sc-mrb9q4-1"
})(["padding:15px;background:", ";border:3px solid ", ";border-radius:3px;"], function (p) {
  return p.theme.colors.grey;
}, function (p) {
  return p.theme.colors.cherryRed;
});
var StyledDescription = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].p.withConfig */ .ZP.p.withConfig({
  displayName: "KeyboardNavigation__StyledDescription",
  componentId: "sc-mrb9q4-2"
})(["text-align:center;font-size:25px;margin:0;padding:0;"]);

var KeyboardNavigation = function KeyboardNavigation(_ref) {
  var refList = _ref.refList;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true),
      hideNav = _useState[0],
      setHideNav = _useState[1]; // Ensures that this component will only show once


  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      seenOnce = _useState2[0],
      setSeenOnce = _useState2[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    function handleKeyDown(e) {
      if (!(e !== null && e !== void 0 && e.key) || seenOnce) return;

      if (e.key === "Tab") {
        e.preventDefault();

        if (hideNav) {
          setHideNav(false);
          return;
        }

        if (!hideNav) {
          setSeenOnce(true);
          setHideNav(true);
          return;
        }
      }

      if (!hideNav && e.key === "Enter") {
        var _refList$, _refList$$current, _refList$2, _refList$2$current;

        (_refList$ = refList[0]) === null || _refList$ === void 0 ? void 0 : (_refList$$current = _refList$.current) === null || _refList$$current === void 0 ? void 0 : _refList$$current.scrollIntoView();
        (_refList$2 = refList[0]) === null || _refList$2 === void 0 ? void 0 : (_refList$2$current = _refList$2.current) === null || _refList$2$current === void 0 ? void 0 : _refList$2$current.focus();
        setSeenOnce(true);
        setHideNav(!hideNav);
      } // Old code that allowed you to navigate to different blocks
      // matches digits 0 - 9
      // if (!hideNav && e.key.match(/^\d+$/)) {
      // refList[e.key - 1]?.current?.scrollIntoView()
      // refList[e.key - 1]?.current?.focus()
      // }

    }

    document.addEventListener("keydown", handleKeyDown); // Clean up event

    return function cleanup() {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [hideNav]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledContainer, {
    hidden: hideNav,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledNavContainer, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledDescription, {
        children: "\u05D3\u05DC\u05D2 \u05DC\u05EA\u05D5\u05DB\u05DF"
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (KeyboardNavigation);

/***/ }),

/***/ 72617:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ accessibility; }
});

// EXTERNAL MODULE: ./common/SeoMetaData.tsx
var SeoMetaData = __webpack_require__(31353);
// EXTERNAL MODULE: ./components/KeyboardNavigation/KeyboardNavigation.tsx
var KeyboardNavigation = __webpack_require__(44203);
// EXTERNAL MODULE: ./components/Texts/TextsPage.tsx
var TextsPage = __webpack_require__(36473);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/Texts/AccessibilityPage.tsx



var AccessibilityPage = function AccessibilityPage(_ref) {
  var data = _ref.data,
      setRefList = _ref.setRefList;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(TextsPage/* default */.Z, {
    title: data === null || data === void 0 ? void 0 : data.title,
    text: data === null || data === void 0 ? void 0 : data.body,
    setRefList: setRefList,
    align: "flex-start"
  });
};

/* harmony default export */ var Texts_AccessibilityPage = (AccessibilityPage);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/pages/accessibility.tsx








var Accessibility = function Accessibility(_ref) {
  var data = _ref.data,
      seo = _ref.seo;

  var _useState = (0,react.useState)([]),
      refList = _useState[0],
      setRefList = _useState[1];

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(KeyboardNavigation/* default */.Z, {
      refList: refList
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SeoMetaData/* default */.ZP, {
      data: seo
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Texts_AccessibilityPage, {
      data: data,
      setRefList: setRefList
    })]
  });
};

var __N_SSG = true;
/* harmony default export */ var accessibility = (Accessibility);

/***/ }),

/***/ 19495:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/accessibility",
      function () {
        return __webpack_require__(72617);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9415,9774,2888,179], function() { return __webpack_exec__(19495); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);